var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.widths),function(item,i){return _c('div',{key:i,staticClass:"h-4 mb-4 skeleton--shade-4",style:(`width: ${_vm.widths[i]}%;`)})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }